import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTracking } from "@/hooks/useInteractionTracking";

interface EventsEmptyStateProps {
  tag?: string | null;
}

const EventsEmptyState = ({ tag }: EventsEmptyStateProps) => {
  const { trackClick } = useTracking();

  const handleWhatsAppClick = () => {
    trackClick("whatsapp_support_empty_state", { tag });
    window.open("https://wa.me/message/MJ6PQHEXDCQCN1", "_blank");
  };

  return (
    <div className="text-center py-8">
      <p className="text-muted-foreground mb-4">
        More experiences will be revealed soon. Have one in mind?
      </p>
      <Button
        variant="outline"
        className="gap-2"
        onClick={handleWhatsAppClick}
      >
        <MessageCircle className="w-4 h-4" />
        Chat with us on WhatsApp
      </Button>
    </div>
  );
};

export default EventsEmptyState;